<template>
  <v-sheet color="transparent" class="px-3 pb-3">
    <v-container fluid class="pa-0 ma-0 fill-height">
      <div @click="hideAttachmentOverlay(), $root.$emit('attachmentIsClosed')">
        <v-overlay z-index="203" :value="viewAttachmentOverlay">
          <v-row justify="center">
            <v-img :src="attachment"></v-img>
          </v-row>
        </v-overlay>
      </div>
      <v-row justify="start" align="stretch" class="fill-height">
        <v-col color="transparent" cols="12" md="8" class="d-flex flex-column pa-0 ma-0">
          <WorkTimeAccount class="flex-grow-1" />
        </v-col>
        <v-col color="transparent" cols="12" md="4" class="d-flex flex-column pa-0 ma-0 pl-3">
          <MiniPublicHolidays class="mb-3 flex-grow-1" />
          <MiniAbsenceAdministration class="flex-grow-1" />
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import WorkTimeAccount from "../components/Administration/WorkTimeAccount";
import MiniPublicHolidays from "../components/Administration/MiniPublicHolidaysAdministartion.vue";
import MiniAbsenceAdministration from "../components/Administration/MiniAbsenceAdministration.vue";

export default {
  name: "Administration",
  route: "Administration",
  components: {
    WorkTimeAccount,
    MiniAbsenceAdministration,
    MiniPublicHolidays
  },
  data: () => ({
    currentTitle: "",
    currentMenu: "administration",
    item: 0,
    absenceUser: undefined,

    menuCol: 2,
    isShrinked: false,
    icon: "mdi-arrow-collapse-left",
    holidaysChange: false,
    absenceChange: false,

    viewAttachmentOverlay: false,
    attachment: null,
    refresh: 0,
    items: []
  }),
  beforeRouteLeave(to, from, next) {
    if (this.holidaysChange || this.absenceChange) {
      this.$dialog
        .confirm(this.$t("changesWillBeLostMessage"), {
          okText: this.$t("ok"),
          cancelText: this.$t("cancel")
        })
        .then(async () => {
          this.holidaysChange = false;
          next();
        })
        .catch((err) => {
          return;
        });
    } else next();
  },
  created: async function () {
    this.items = [...this.allItems];
    this.currentTitle = this.$t("userAdministration");
    if (this.$route.query.page) {
      let page = null;
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].value.toLowerCase() === this.$route.query.page.toLowerCase()) {
          page = this.items[i];
          this.item = i;
          break;
        }
      }
      if (page !== undefined) {
        this.changeMenu(page);
      } else {
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].value.toLowerCase() === "administraton") {
            page = this.items[i];
            this.item = i;
            break;
          }
        }
        this.changeMenu(item);
      }
    }

    if (this.$route.query.page && this.$route.query.page.toLowerCase() === "absencecalendar" && this.$route.query.user) {
      this.absenceUser = this.$route.query.user;
    }

    await this.getStatus();
    await this.getSettings();
    await this.setSettings();
    await this.getAbsenceReason();
  },
  mounted() {
    this.$root.$on("absenceChange", (val) => {
      if (val.length != 0) this.absenceChange = true;
      else this.absenceChange = false;
    });
    this.$root.$on("attachmentIsOpened", (val) => {
      this.viewAttachmentOverlay = true;
      this.attachment = val;
    });
  },
  beforeDestroy() {
    this.$root.$on("absenceChange", this.fn);
    this.$root.$on("attachmentIsOpened", this.fn);
  },
  methods: {
    shrink: function () {
      if (this.menuCol == 2) {
        this.isShrinked = true;
        this.menuCol = 1;
        this.icon = "mdi-arrow-collapse-right";
      } else {
        this.isShrinked = false;
        this.menuCol = 2;
        this.icon = "mdi-arrow-collapse-left";
      }
    },
    holidaysChangeFunction(val) {
      this.holidaysChange = val;
    },
    async getStatus() {
      await this.$store
        .dispatch("user/getStatus", {
          timeStamp: this.$moment(),
          executeImmediately: false
        })
        .then(() => {
          if (!this.$store.getters["user/user"].userGroupRights.canAccessUserAdministration) this.$router.push("Login");
        })
        .catch((err) => {
          if (err.response.status != 200) {
            this.showMessage(err.response.data);
          }
        });
    },
    async settingsChanged() {
      await this.getSettings();
      this.items = [...this.allItems];
      this.refresh++;
      this.setSettings();
    },
    setSettings() {
      let stageProjectsOn = this.$store.getters["server/stageProjectsAllowed"] == 1 ? true : false;
      let serviceCallsOn = this.$store.getters["server/serviceCallsAllowed"] == 1 ? true : false;

      if (!stageProjectsOn) {
        let index = this.items.findIndex((item) => item.value == "projectpermissions");

        this.items.splice(index, 1);
      }
      if (!serviceCallsOn) {
        let index = this.items.findIndex((item) => item.value == "servicecallpermissions");

        this.items.splice(index, 1);
      }
      this.refresh++;
    },
    changeMenuClicked(item) {
      if (this.$route.query.user) {
        this.$router.replace({ query: null });
        this.absenceUser = undefined;
      }
      this.changeMenu(item);
    },
    changeMenu(item) {
      if (this.holidaysChange || this.absenceChange) {
        this.$dialog
          .confirm(this.$t("changesWillBeLostMessage"))
          .then(async () => {
            this.currentTitle = item.text;
            this.currentMenu = item.value;
            this.holidaysChange = false;
            this.absenceChange = false;
          })
          .catch((err) => {
            this.item = 4;
            return;
          });
      } else {
        this.currentTitle = item.text;
        this.currentMenu = item.value;
      }
    },
    hideAttachmentOverlay() {
      this.viewAttachmentOverlay = false;
    },
    async getSettings() {
      this.loaderOverlay = true;
      await this.$store
        .dispatch("server/getSettings", this.$moment())
        .then(() => {})
        .catch((err) => {
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", err.response.data.error, "bottom", "right");
          }
        });
      this.loaderOverlay = false;
    },
    async getAbsenceReason() {
      //this.loaderMessage = this.$t("getAbsences") + "..";
      await this.$store
        .dispatch("server/getAbsenceReasons")
        .then(() => {
          this.loaderOverlay = false;
        })
        .catch((err) => {
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", err.response.data, "bottom", "right");
          }
        });
    }
  },
  computed: {
    allItems: function () {
      return [
        {
          text: this.$t("userAdministration"),
          value: "administration",
          icon: "mdi-account"
        },
        {
          text: this.$t("generalSettings"),
          value: "settings",
          icon: "mdi-cog-outline"
        },
        {
          text: this.$t("timeModels"),
          value: "worktimeaccount",
          icon: "mdi-clock-outline"
        },
        {
          text: this.$t("timeReport"),
          value: "timereport",
          icon: "mdi-file-chart"
        },
        {
          text: this.$t("publicHolidayManagement"),
          value: "holidaysAdministration",
          icon: "mdi-calendar-month "
        },
        {
          text: this.$t("projectPerms"),
          value: "projectpermissions",
          icon: "mdi-beaker-plus"
        },
        {
          text: this.$t("serviceCallPermissions"),
          value: "servicecallpermissions",
          icon: "mdi-beaker-plus"
        }
        // {
        //   text: this.$t("usergroups"),
        //   value: "userGroups",
        //   icon: "mdi-account-edit"
        // }
      ];
    }
  }
};
</script>

<style></style>
